// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter__group {\n  border-bottom: 0.0625rem solid #20212a;\n  padding: 1.25rem 0;\n}", "",{"version":3,"sources":["webpack://./src/Containers/Home/Home.scss"],"names":[],"mappings":"AAGE;EACE,sCAAA;EACA,kBAAA;AAFJ","sourcesContent":["@import 'src/scss/abstracts/variables';\n\n.filter {\n  &__group {\n    border-bottom: 0.0625rem solid $black;\n    padding: 1.25rem 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
